export const googleClientId = process.env.REACT_APP_GOOGLE_CLIENT_ID
  || '132447884525-agih5hbdvcnol6ftqo8na3sk3sf0i1sv.apps.googleusercontent.com'
